<template>
  <div
    class="custom-marker absolute z-50 pointer-events-auto flex items-center justify-center w-0 h-0"
    :style="markerStyle"
    @click="handleClick"
    @mousedown="handleMouseDown"
    @touchstart="handleTouchStart"
    :class="{
      'cursor-move': props.markerData.draggable,
      'cursor-grabbing': isDragging,
      // 'transition-transform delay-[35ms] duration-[200ms] ease-in': isZoom,
    }"
  >
    <!-- Position utilisateur -->
    <div v-if="markerData.isUserPosition" class="absolute">
      <div
        class="w-12 h-12 p-3 rounded-full bg-blue-500 border-blue-600 flex items-center justify-center transition-transform duration-200"
        :style="{ transform: `rotate(${markerData.heading || 0}deg)` }"
      >
        <!-- <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />
        </svg> -->
      </div>
      <!-- <div
        class="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white animate-pulse"
      ></div> -->
    </div>
    <div class="absolute bottom-0 w-12" v-else>
      <ColorImg
        src="/images/icons/map-location-container.png"
        :fallback="locationImage"
        class="w-full"
        :class="{
          'bg-primary': markerData.iconType === 'pickup',
          'bg-blue-500': markerData.iconType === 'checkpoint',
          'bg-red-500': markerData.iconType === 'destination',
          'bg-purple-500': !['pickup', 'checkpoint', 'destination'].includes(
            markerData.iconType,
          ),
        }"
      />
      <div class="absolute py-[50%] w-full z-[2] top-0 left-0" v-if="false">
        <div class="absolute w-full h-full p-[1px] top-0">
          <!-- Restaurant / Départ -->
          <div v-if="markerData.iconType === 'pickup'" class="relative">
            <div
              class="w-full h-full p-2 rounded-full bg-orange-500 border-orange-600 flex items-center justify-center"
            >
              <svg
                class="w-full h-full text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                />
              </svg>
            </div>
          </div>

          <!-- Points de passage / Checkpoints -->
          <div
            v-else-if="markerData.iconType === 'checkpoint'"
            class="relative"
          >
            <div
              class="w-full h-full p-1.5 rounded-full bg-blue-500 border-blue-600 flex items-center justify-center"
            >
              <svg
                class="w-full h-full text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
            </div>
            <div
              class="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 rounded-full border-2 border-white flex items-center justify-center shadow-md"
            >
              <span class="text-white text-xs font-bold">{{
                markerData.checkpointNumber || '?'
              }}</span>
            </div>
          </div>

          <!-- Destination / Arrivée -->
          <div
            v-else-if="markerData.iconType === 'destination'"
            class="relative"
          >
            <div
              class="w-full h-full p-2 rounded-full bg-red-500 border-red-600 flex items-center justify-center"
            >
              <svg
                class="w-full h-full text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
              </svg>
            </div>
            <!-- <div
              class="absolute -top-1 -right-1 w-5 h-5 bg-red-600 rounded-full border-2 border-white flex items-center justify-center shadow-md"
            >
              <span class="text-white text-xs font-bold">D</span>
            </div> -->
          </div>

          <!-- Marqueur par défaut -->
          <div v-else>
            <div
              class="absolute w-10 h-10 p-2 rounded-full bg-purple-500 border-purple-600 flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition
      v-if="false"
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="hasTooltip && showTooltip"
        class="custom-tooltip absolute top-0 mt-4 bg-white text-black px-3 py-2 rounded-lg shadow-lg whitespace-nowrap z-50 pointer-events-none"
      >
        <div class="font-semibold text-sm">{{ tooltipText }}</div>
        <div
          class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full"
        >
          <div
            class="w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-white"
          ></div>
        </div>
      </div>
    </Transition>
    <!-- </div> -->
  </div>
</template>

<script setup>
import ColorImg from '@ui/core/img/ColorImg.global.vue'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import locationImage from './images/location.png'

const props = defineProps({
  markerData: {
    type: Object,
    required: true,
  },
  mapInstance: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['click', 'dragend'])

const showTooltip = ref(false)
const isZoom = ref(false)
const isDragging = ref(false)
const forceUpdate = ref(0) // Used to force re-renders
let mapEventListeners = []

const hasTooltip = computed(() => {
  return !!(props.markerData.content || props.markerData.options?.title)
})

const tooltipText = computed(() => {
  return (
    props.markerData.content ||
    props.markerData.options?.title ||
    "Point d'intérêt"
  )
})

const markerStyle = computed(() => {
  // Include forceUpdate in dependencies to trigger recalculation
  forceUpdate.value
  const position = props.markerData.position
  if (!position || !position.lat || !position.lng) {
    return {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 50,
    }
  }

  // Return center position if map is not ready
  if (
    !props.mapInstance ||
    !props.mapInstance.getProjection() ||
    !props.mapInstance.getDiv()
  ) {
    return {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 50,
    }
  }

  try {
    const latLng = new google.maps.LatLng(position.lat, position.lng)
    const mapDiv = props.mapInstance.getDiv()
    const mapRect = mapDiv.getBoundingClientRect()
    const projection = props.mapInstance.getProjection()
    const bounds = props.mapInstance.getBounds()

    if (!bounds) {
      return {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 50,
      }
    }

    // Google Maps coordinate conversion
    const ne = projection.fromLatLngToPoint(bounds.getNorthEast())
    const sw = projection.fromLatLngToPoint(bounds.getSouthWest())
    const worldWidth = ne.x - sw.x
    const worldHeight = sw.y - ne.y
    const point = projection.fromLatLngToPoint(latLng)

    // Calculate pixel position relative to map container
    const x = ((point.x - sw.x) / worldWidth) * mapRect.width
    const y = ((point.y - ne.y) / worldHeight) * mapRect.height

    // Check if marker is visible (optional optimization)
    const isVisible = bounds.contains(latLng)

    const style = {
      position: 'absolute',
      // left: `${x}px`,
      // top: `${y}px`,
      left: `0px`,
      top: `0px`,
      // transform: 'translate(-50%, -50%)',
      transform: `translate(${x}px, ${y}px)`,
      display: isVisible ? 'flex' : 'none',
      zIndex: 50,
      willChange: 'transform', // Optimize for animations
    }

    return style
  } catch (error) {
    console.warn('Error calculating marker position:', error, props.markerData)
    return {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 50,
    }
  }
})

const handleClick = event => {
  event.stopPropagation()

  // Toggle tooltip on click for mobile
  showTooltip.value = !showTooltip.value

  emit('click', props.markerData)
}

// Écouter les changements de position pour les mises à jour dynamiques
watch(
  () => props.markerData.position,
  newPos => {
    // Force update when position changes
    forceUpdate.value++
  },
  { deep: true },
)

// Function to add map event listeners
const addMapListeners = map => {
  if (!map) return

  // Instant update function - no delay
  const instantUpdate = () => {
    forceUpdate.value++
  }
  const instantUpdateZoom = () => {
    isZoom.value = true
    instantUpdate()
    setTimeout(() => {
      isZoom.value = false
    }, 100)
  }

  // Add listeners for immediate updates
  const boundsListener = map.addListener('bounds_changed', instantUpdate)
  const zoomListener = map.addListener('zoom_changed', instantUpdateZoom)
  const centerListener = map.addListener('center_changed', instantUpdate)
  const dragListener = map.addListener('drag', instantUpdate)
  const dragEndListener = map.addListener('dragend', instantUpdate)

  // Also listen to projection changes
  const projectionListener = map.addListener(
    'projection_changed',
    instantUpdate,
  )

  mapEventListeners.push(
    boundsListener,
    zoomListener,
    centerListener,
    dragListener,
    dragEndListener,
    projectionListener,
  )
}

// Function to remove map event listeners
const removeMapListeners = () => {
  mapEventListeners.forEach(listener => {
    if (listener && listener.remove) {
      listener.remove()
    }
  })
  mapEventListeners = []

  // Clear timeout on cleanup
  // if (updateTimeout) {
  //   clearTimeout(updateTimeout)
  //   updateTimeout = null
  // }
}

watch(
  () => props.mapInstance,
  newInstance => {
    // Remove old listeners
    removeMapListeners()

    // Add new listeners if map instance is available
    if (newInstance) {
      addMapListeners(newInstance)
    }
  },
  { immediate: true },
)

// Lifecycle hooks
onMounted(() => {
  if (props.mapInstance) {
    addMapListeners(props.mapInstance)
  }
})

onBeforeUnmount(() => {
  removeMapListeners()
  stopDragging()
})

// Drag and drop functionality
let dragStartPos = null
let dragStartLatLng = null

function handleMouseDown(event) {
  if (!props.markerData.draggable || !props.mapInstance) return
  event.preventDefault()
  event.stopPropagation()

  isDragging.value = true

  dragStartPos = { x: event.clientX, y: event.clientY }
  dragStartLatLng = props.markerData.position

  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseup', handleMouseUp)
}

function handleMouseMove(event) {
  if (!isDragging.value || !props.mapInstance) return

  // Calculate pixel delta
  const deltaX = event.clientX - dragStartPos.x
  const deltaY = event.clientY - dragStartPos.y

  // Convert pixel delta to lat/lng
  const projection = props.mapInstance.getProjection()
  const bounds = props.mapInstance.getBounds()
  const mapDiv = props.mapInstance.getDiv()
  const mapRect = mapDiv.getBoundingClientRect()

  if (!projection || !bounds) return

  // Convert start position to world coordinates
  const startLatLng = new google.maps.LatLng(
    dragStartLatLng.lat,
    dragStartLatLng.lng,
  )
  const startPoint = projection.fromLatLngToPoint(startLatLng)

  // Convert pixel delta to world coordinate delta
  const ne = projection.fromLatLngToPoint(bounds.getNorthEast())
  const sw = projection.fromLatLngToPoint(bounds.getSouthWest())
  const worldWidth = ne.x - sw.x
  const worldHeight = sw.y - ne.y

  const worldDeltaX = (deltaX / mapRect.width) * worldWidth
  const worldDeltaY = (deltaY / mapRect.height) * worldHeight

  // Calculate new world coordinates
  const newWorldX = startPoint.x + worldDeltaX
  const newWorldY = startPoint.y + worldDeltaY

  // Convert back to lat/lng
  const newPoint = new google.maps.Point(newWorldX, newWorldY)
  const newLatLng = projection.fromPointToLatLng(newPoint)

  // Update marker position
  if (newLatLng) {
    const newPosition = { lat: newLatLng.lat(), lng: newLatLng.lng() }
    props.markerData.position = newPosition
    forceUpdate.value++
  }
}

function handleMouseUp(event) {
  if (!isDragging.value) return

  stopDragging()

  // Emit dragend event with new position
  if (props.markerData.position && props.mapInstance) {
    emit('dragend', {
      latLng: {
        lat: () => props.markerData.position.lat,
        lng: () => props.markerData.position.lng,
      },
      position: props.markerData.position,
    })
  }
}

function handleTouchStart(event) {
  if (!props.markerData.draggable || !props.mapInstance) return
  event.preventDefault()
  event.stopPropagation()

  const touch = event.touches[0]
  isDragging.value = true

  dragStartPos = { x: touch.clientX, y: touch.clientY }
  dragStartLatLng = props.markerData.position

  document.addEventListener('touchmove', handleTouchMove, { passive: false })
  document.addEventListener('touchend', handleTouchEnd)
}

function handleTouchMove(event) {
  if (!isDragging.value) return
  event.preventDefault()

  const touch = event.touches[0]

  // Calculate pixel delta
  const deltaX = touch.clientX - dragStartPos.x
  const deltaY = touch.clientY - dragStartPos.y

  // Convert pixel delta to lat/lng (same logic as mouse move)
  const projection = props.mapInstance.getProjection()
  const bounds = props.mapInstance.getBounds()
  const mapDiv = props.mapInstance.getDiv()
  const mapRect = mapDiv.getBoundingClientRect()

  if (!projection || !bounds) return

  const startLatLng = new google.maps.LatLng(
    dragStartLatLng.lat,
    dragStartLatLng.lng,
  )
  const startPoint = projection.fromLatLngToPoint(startLatLng)

  const ne = projection.fromLatLngToPoint(bounds.getNorthEast())
  const sw = projection.fromLatLngToPoint(bounds.getSouthWest())
  const worldWidth = ne.x - sw.x
  const worldHeight = sw.y - ne.y

  const worldDeltaX = (deltaX / mapRect.width) * worldWidth
  const worldDeltaY = (deltaY / mapRect.height) * worldHeight

  const newWorldX = startPoint.x + worldDeltaX
  const newWorldY = startPoint.y + worldDeltaY

  const newPoint = new google.maps.Point(newWorldX, newWorldY)
  const newLatLng = projection.fromPointToLatLng(newPoint)

  if (newLatLng) {
    const newPosition = { lat: newLatLng.lat(), lng: newLatLng.lng() }
    props.markerData.position = newPosition
    forceUpdate.value++
  }
}

function handleTouchEnd(event) {
  if (!isDragging.value) return

  stopDragging()

  // Emit dragend event with new position
  if (props.markerData.position && props.mapInstance) {
    emit('dragend', {
      latLng: {
        lat: () => props.markerData.position.lat,
        lng: () => props.markerData.position.lng,
      },
      position: props.markerData.position,
    })
  }
}

function stopDragging() {
  isDragging.value = false
  dragStartPos = null
  dragStartLatLng = null

  document.removeEventListener('mousemove', handleMouseMove)
  document.removeEventListener('mouseup', handleMouseUp)
  document.removeEventListener('touchmove', handleTouchMove)
  document.removeEventListener('touchend', handleTouchEnd)
}
</script>

<style scoped>
.custom-marker {
  will-change: transform, opacity;
  backface-visibility: hidden;
  transform: translateZ(0); /* GPU acceleration */
}

.custom-tooltip {
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
